// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Entity/ExerciceDetailModal.css */
/* Modal for detailed charge editing per exercice */

/* ===================== OVERLAY ===================== */

.exercice-detail-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.15s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* ===================== MODAL ===================== */

.exercice-detail-modal {
  background: white;
  border-radius: 16px;
  width: 1100px;
  max-width: 95vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.2s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===================== HEADER ===================== */

.exercice-detail-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  color: white;
}

.exercice-detail-modal .header-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.exercice-detail-modal .entity-badge-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
}

.exercice-detail-modal .legal-form-badge {
  padding: 2px 8px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
}

.exercice-detail-modal .entity-name {
  font-size: 13px;
  font-weight: 600;
}

.exercice-detail-modal .tax-regime-badge {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
}

.exercice-detail-modal .tax-regime-badge.is {
  background: #3B82F6;
}

.exercice-detail-modal .tax-regime-badge.ir {
  background: #10B981;
}

.exercice-detail-modal .header-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.exercice-detail-modal .header-info h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.exercice-detail-modal .ca-badge {
  padding: 4px 12px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  font-size: 13px;
  font-weight: 500;
}

.exercice-detail-modal .close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.exercice-detail-modal .close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* ===================== BODY ===================== */

.exercice-detail-modal .modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
}

/* ===================== CHARGES SECTION ===================== */

.exercice-detail-modal .charges-section {
  margin-bottom: 24px;
}

.exercice-detail-modal .charges-section h4 {
  font-size: 14px;
  font-weight: 600;
  color: #1E293B;
  margin: 0 0 8px 0;
}

.exercice-detail-modal .section-hint {
  font-size: 12px;
  color: #64748B;
  margin: 0 0 16px 0;
  line-height: 1.4;
}

.exercice-detail-modal .charges-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ===================== CHARGE ITEM ===================== */

.exercice-detail-modal .charge-item {
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  padding: 12px 14px;
  transition: all 0.2s;
}

.exercice-detail-modal .charge-item.overridden {
  background: #FEF3C7;
  border-color: #F59E0B;
}

.exercice-detail-modal .charge-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.exercice-detail-modal .charge-icon {
  font-size: 16px;
}

.exercice-detail-modal .charge-label {
  flex: 1 1;
  font-size: 13px;
  font-weight: 500;
  color: #1E293B;
}

.exercice-detail-modal .reset-btn {
  width: 24px;
  height: 24px;
  background: white;
  border: 1px solid #D97706;
  border-radius: 4px;
  font-size: 14px;
  color: #D97706;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.exercice-detail-modal .reset-btn:hover {
  background: #D97706;
  color: white;
}

.exercice-detail-modal .charge-input-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.exercice-detail-modal .input-wrapper {
  display: flex;
  align-items: center;
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  overflow: hidden;
  width: 160px;
}

.exercice-detail-modal .input-wrapper input {
  flex: 1 1;
  padding: 8px 10px;
  border: none;
  font-size: 14px;
  text-align: right;
  width: 100%;
}

.exercice-detail-modal .input-wrapper input:focus {
  outline: none;
}

.exercice-detail-modal .input-wrapper input.manual {
  background: #FEF3C7;
  font-weight: 500;
  color: #D97706;
}

.exercice-detail-modal .input-wrapper .suffix {
  padding: 0 10px;
  font-size: 12px;
  color: #94A3B8;
  background: #F8FAFC;
}

.exercice-detail-modal .hypothesis-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.exercice-detail-modal .formula {
  font-size: 10px;
  color: #94A3B8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.exercice-detail-modal .hypothesis-value {
  font-size: 12px;
  color: #64748B;
}

.exercice-detail-modal .override-notice {
  margin-top: 6px;
  font-size: 11px;
  color: #D97706;
  font-style: italic;
}

/* ===================== SUMMARY SECTION ===================== */

.exercice-detail-modal .summary-section {
  background: #F8FAFC;
  border-radius: 12px;
  padding: 16px;
}

.exercice-detail-modal .summary-section h4 {
  font-size: 14px;
  font-weight: 600;
  color: #1E293B;
  margin: 0 0 12px 0;
}

.exercice-detail-modal .summary-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.exercice-detail-modal .summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
}

.exercice-detail-modal .summary-row .row-label {
  font-size: 13px;
  color: #64748B;
}

.exercice-detail-modal .summary-row .row-value {
  font-size: 14px;
  font-weight: 500;
  color: #1E293B;
}

.exercice-detail-modal .summary-row .row-value.negative {
  color: #DC2626;
}

.exercice-detail-modal .summary-row.resultat {
  border-top: 1px solid #E2E8F0;
  padding-top: 10px;
  margin-top: 4px;
}

.exercice-detail-modal .summary-row.is .is-detail {
  font-size: 11px;
  color: #94A3B8;
  margin-left: 6px;
}

.exercice-detail-modal .summary-row.highlight {
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  margin: 8px -16px -16px;
  padding: 12px 16px;
  border-radius: 0 0 12px 12px;
}

.exercice-detail-modal .summary-row.highlight .row-label,
.exercice-detail-modal .summary-row.highlight .row-value {
  color: white;
  font-weight: 600;
}

.exercice-detail-modal .ir-notice {
  padding: 12px;
  background: #EFF6FF;
  border: 1px solid #BFDBFE;
  border-radius: 8px;
  font-size: 12px;
  color: #1E40AF;
  text-align: center;
}

/* ===================== FOOTER ===================== */

.exercice-detail-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 20px;
  border-top: 1px solid #E2E8F0;
  background: #FAFAFA;
}

.exercice-detail-modal .btn-cancel {
  padding: 10px 20px;
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s;
}

.exercice-detail-modal .btn-cancel:hover {
  background: #F1F5F9;
  border-color: #CBD5E1;
}

.exercice-detail-modal .btn-save {
  padding: 10px 24px;
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
}

.exercice-detail-modal .btn-save:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}

/* ===================== DETAIL SECTIONS ===================== */

.exercice-detail-modal .detail-section {
  background: #F8FAFC;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 16px;
  border: 1px solid #E2E8F0;
}

.exercice-detail-modal .detail-section h4 {
  font-size: 13px;
  font-weight: 600;
  color: #1E293B;
  margin: 0 0 10px 0;
}

.exercice-detail-modal .detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  font-size: 13px;
  color: #475569;
}

.exercice-detail-modal .detail-row span.negative {
  color: #DC2626;
  font-weight: 500;
}

.exercice-detail-modal .detail-row.total {
  border-top: 1px solid #E2E8F0;
  margin-top: 6px;
  padding-top: 10px;
  font-weight: 600;
}

.exercice-detail-modal .detail-row.total span {
  color: #1E293B;
}

/* ===================== ACRE BADGE ===================== */

.exercice-detail-modal .acre-badge {
  display: inline-block;
  padding: 2px 6px;
  background: #DCFCE7;
  color: #16A34A;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 600;
  margin-left: 6px;
}

/* ===================== EXEMPTION NOTE ===================== */

.exercice-detail-modal .exemption-note {
  font-size: 10px;
  color: #16A34A;
  font-style: italic;
  margin-left: 4px;
}

/* ===================== RESPONSIVE ===================== */

@media (max-width: 640px) {
  .exercice-detail-modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }

  .exercice-detail-modal .charge-input-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .exercice-detail-modal .input-wrapper {
    width: 100%;
  }

  .exercice-detail-modal .hypothesis-info {
    flex-direction: row;
    gap: 8px;
  }
}

/* ===================== YEAR BADGE ===================== */

.exercice-detail-modal .year-badge {
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
}

.exercice-detail-modal .year-badge.first {
  background: #DCFCE7;
  color: #16A34A;
}

.exercice-detail-modal .year-badge.second {
  background: #FEF3C7;
  color: #D97706;
}

/* ===================== ACTIVE OPTIONS BAR ===================== */

.exercice-detail-modal .active-options-bar {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  min-height: 28px;
}

.exercice-detail-modal .option-tag {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

.exercice-detail-modal .option-tag.acre {
  background: #DCFCE7;
  color: #16A34A;
}

.exercice-detail-modal .option-tag.jei {
  background: #DBEAFE;
  color: #2563EB;
}

.exercice-detail-modal .option-tag.cir {
  background: #F3E8FF;
  color: #9333EA;
}

.exercice-detail-modal .option-tag.mf {
  background: #FEF3C7;
  color: #D97706;
}

.exercice-detail-modal .option-tag.cga {
  background: #E0E7FF;
  color: #4F46E5;
}

/* ===================== CA SECTION EDITABLE ===================== */

.exercice-detail-modal .detail-row.editable {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.exercice-detail-modal .edit-value {
  display: flex;
  align-items: center;
  gap: 6px;
}

.exercice-detail-modal .edit-value input {
  width: 140px;
  padding: 8px 12px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 14px;
  text-align: right;
}

.exercice-detail-modal .edit-value input:focus {
  outline: none;
  border-color: #F59E0B;
}

.exercice-detail-modal .edit-value input.overridden {
  background: #FEF3C7;
  border-color: #F59E0B;
  font-weight: 500;
}

.exercice-detail-modal .edit-value .suffix {
  font-size: 13px;
  color: #64748B;
}

.exercice-detail-modal .override-note {
  font-size: 11px;
  color: #D97706;
  font-style: italic;
  margin-top: 4px;
  text-align: right;
}

/* ===================== MANAGER DETAIL ROW ===================== */

.exercice-detail-modal .manager-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #E2E8F0;
}

.exercice-detail-modal .manager-detail-row:last-of-type {
  border-bottom: none;
}

.exercice-detail-modal .manager-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.exercice-detail-modal .manager-role {
  font-weight: 500;
  color: #1E293B;
  font-size: 13px;
}

.exercice-detail-modal .status-badge {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
}

.exercice-detail-modal .status-badge.tns {
  background: #FEE2E2;
  color: #DC2626;
}

.exercice-detail-modal .status-badge.as {
  background: #DBEAFE;
  color: #2563EB;
}

.exercice-detail-modal .tag-small {
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
}

.exercice-detail-modal .tag-small.acre {
  background: #DCFCE7;
  color: #16A34A;
}

.exercice-detail-modal .tag-small.jei {
  background: #DBEAFE;
  color: #2563EB;
}

.exercice-detail-modal .manager-amounts {
  display: flex;
  gap: 16px;
}

.exercice-detail-modal .amount-item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.exercice-detail-modal .amount-item label {
  font-size: 10px;
  color: #94A3B8;
  text-transform: uppercase;
}

.exercice-detail-modal .amount-item span {
  font-size: 13px;
  font-weight: 500;
  color: #1E293B;
}

.exercice-detail-modal .amount-item span.negative {
  color: #DC2626;
}

.exercice-detail-modal .amount-item.total span {
  font-weight: 600;
  font-size: 14px;
}

/* ===================== CIR CREDIT ROW ===================== */

.exercice-detail-modal .summary-row.cir-credit {
  padding-left: 20px;
}

.exercice-detail-modal .summary-row.cir-credit .row-label {
  font-size: 12px;
  font-style: italic;
}

.exercice-detail-modal .row-value.positive {
  color: #16A34A;
  font-weight: 500;
}

/* ===================== HEADER ACTIONS ===================== */

.exercice-detail-modal .header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.exercice-detail-modal .toggle-formulas {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
}

.exercice-detail-modal .toggle-formulas input {
  accent-color: white;
}

/* ===================== MODAL COLUMNS ===================== */

.exercice-detail-modal .modal-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.exercice-detail-modal .modal-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ===================== CHARGES OBLIGATOIRES ===================== */

.exercice-detail-modal .section-subtitle {
  font-size: 11px;
  color: #64748B;
  margin: 0 0 12px 0;
}

.exercice-detail-modal .charges-group {
  margin-bottom: 16px;
}

.exercice-detail-modal .group-label {
  display: block;
  font-size: 10px;
  font-weight: 600;
  color: #94A3B8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid #E2E8F0;
}

/* ===================== EDITABLE ROW ===================== */

.exercice-detail-modal .row-label-with-help {
  display: flex;
  align-items: center;
  gap: 6px;
}

.exercice-detail-modal .tooltip-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.exercice-detail-modal .help-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background: #E2E8F0;
  border-radius: 50%;
  font-size: 10px;
  font-weight: 600;
  color: #64748B;
  cursor: help;
  transition: all 0.15s;
}

.exercice-detail-modal .help-icon:hover {
  background: #3B82F6;
  color: white;
}

.exercice-detail-modal .tooltip-content {
  position: absolute;
  left: 24px;
  top: 50%;
  transform: translateY(-50%);
  background: #1E293B;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  max-width: 300px;
  white-space: normal;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  animation: tooltipFadeIn 0.15s ease-out;
}

.exercice-detail-modal .tooltip-content::before {
  content: '';
  position: absolute;
  left: -6px;
  top: 50%;
  transform: translateY(-50%);
  border: 6px solid transparent;
  border-right-color: #1E293B;
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateY(-50%) translateX(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
}

/* Hint pour pas de charges */
.exercice-detail-modal .no-charges-hint {
  font-size: 12px;
  color: #94A3B8;
  font-style: italic;
  padding: 8px 0;
}

.exercice-detail-modal .row-value-edit {
  display: flex;
  align-items: center;
  gap: 8px;
}

.exercice-detail-modal .formula-hint {
  font-size: 10px;
  color: #94A3B8;
  font-style: italic;
  white-space: nowrap;
}

.exercice-detail-modal .detail-row.overridden {
  background: #FEF3C7;
  border-color: #F59E0B;
}

/* ===================== SECTION TOTAL ===================== */

.exercice-detail-modal .section-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  margin-top: 8px;
  border-top: 1px solid #E2E8F0;
  font-weight: 600;
}

.exercice-detail-modal .section-total .negative {
  color: #DC2626;
}

/* ===================== MANAGER EDIT ===================== */

.exercice-detail-modal .manager-edit {
  display: flex;
  align-items: center;
  gap: 8px;
}

.exercice-detail-modal .edit-value.compact {
  display: flex;
  align-items: center;
  gap: 4px;
}

.exercice-detail-modal .edit-value.compact input {
  width: 100px;
  padding: 6px 8px;
  font-size: 13px;
}

/* ===================== NO OPTIONS ===================== */

.exercice-detail-modal .no-options {
  font-size: 12px;
  color: #94A3B8;
  font-style: italic;
}

/* ===================== FOOTER INFO ===================== */

.exercice-detail-modal .modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-top: 1px solid #E2E8F0;
  background: #FAFAFA;
}

.exercice-detail-modal .footer-info {
  flex: 1 1;
}

.exercice-detail-modal .override-count {
  font-size: 12px;
  color: #D97706;
  font-weight: 500;
}

.exercice-detail-modal .footer-actions {
  display: flex;
  gap: 10px;
}

/* ===================== RESPONSIVE ===================== */

@media (max-width: 900px) {
  .exercice-detail-modal .modal-columns {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Entity/ExerciceDetailModal.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,mDAAmD;;AAEnD,wDAAwD;;AAExD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,sDAAsD;;AAEtD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,uDAAuD;;AAEvD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qDAAqD;;AAErD;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,gEAAgE;;AAEhE;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,4DAA4D;;AAE5D;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,gEAAgE;;AAEhE;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,uDAAuD;;AAEvD;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,gEAAgE;;AAEhE;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,2DAA2D;;AAE3D;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+DAA+D;;AAE/D;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2DAA2D;;AAE3D;EACE;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,QAAQ;EACV;AACF;;AAEA,2DAA2D;;AAE3D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oEAAoE;;AAEpE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,+DAA+D;;AAE/D;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8DAA8D;;AAE9D;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qEAAqE;;AAErE;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,6DAA6D;;AAE7D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,8DAA8D;;AAE9D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,6DAA6D;;AAE7D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2DAA2D;;AAE3D;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,2DAA2D;;AAE3D;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* src/components/Entity/ExerciceDetailModal.css */\n/* Modal for detailed charge editing per exercice */\n\n/* ===================== OVERLAY ===================== */\n\n.exercice-detail-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.15s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* ===================== MODAL ===================== */\n\n.exercice-detail-modal {\n  background: white;\n  border-radius: 16px;\n  width: 1100px;\n  max-width: 95vw;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: slideUp 0.2s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ===================== HEADER ===================== */\n\n.exercice-detail-modal .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  color: white;\n}\n\n.exercice-detail-modal .header-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.exercice-detail-modal .entity-badge-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 2px;\n}\n\n.exercice-detail-modal .legal-form-badge {\n  padding: 2px 8px;\n  background: rgba(255, 255, 255, 0.25);\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.exercice-detail-modal .entity-name {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.exercice-detail-modal .tax-regime-badge {\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.exercice-detail-modal .tax-regime-badge.is {\n  background: #3B82F6;\n}\n\n.exercice-detail-modal .tax-regime-badge.ir {\n  background: #10B981;\n}\n\n.exercice-detail-modal .header-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.exercice-detail-modal .header-info h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.exercice-detail-modal .ca-badge {\n  padding: 4px 12px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 16px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.exercice-detail-modal .close-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: white;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.exercice-detail-modal .close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* ===================== BODY ===================== */\n\n.exercice-detail-modal .modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n/* ===================== CHARGES SECTION ===================== */\n\n.exercice-detail-modal .charges-section {\n  margin-bottom: 24px;\n}\n\n.exercice-detail-modal .charges-section h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1E293B;\n  margin: 0 0 8px 0;\n}\n\n.exercice-detail-modal .section-hint {\n  font-size: 12px;\n  color: #64748B;\n  margin: 0 0 16px 0;\n  line-height: 1.4;\n}\n\n.exercice-detail-modal .charges-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* ===================== CHARGE ITEM ===================== */\n\n.exercice-detail-modal .charge-item {\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  border-radius: 10px;\n  padding: 12px 14px;\n  transition: all 0.2s;\n}\n\n.exercice-detail-modal .charge-item.overridden {\n  background: #FEF3C7;\n  border-color: #F59E0B;\n}\n\n.exercice-detail-modal .charge-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.exercice-detail-modal .charge-icon {\n  font-size: 16px;\n}\n\n.exercice-detail-modal .charge-label {\n  flex: 1;\n  font-size: 13px;\n  font-weight: 500;\n  color: #1E293B;\n}\n\n.exercice-detail-modal .reset-btn {\n  width: 24px;\n  height: 24px;\n  background: white;\n  border: 1px solid #D97706;\n  border-radius: 4px;\n  font-size: 14px;\n  color: #D97706;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.exercice-detail-modal .reset-btn:hover {\n  background: #D97706;\n  color: white;\n}\n\n.exercice-detail-modal .charge-input-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.exercice-detail-modal .input-wrapper {\n  display: flex;\n  align-items: center;\n  background: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  overflow: hidden;\n  width: 160px;\n}\n\n.exercice-detail-modal .input-wrapper input {\n  flex: 1;\n  padding: 8px 10px;\n  border: none;\n  font-size: 14px;\n  text-align: right;\n  width: 100%;\n}\n\n.exercice-detail-modal .input-wrapper input:focus {\n  outline: none;\n}\n\n.exercice-detail-modal .input-wrapper input.manual {\n  background: #FEF3C7;\n  font-weight: 500;\n  color: #D97706;\n}\n\n.exercice-detail-modal .input-wrapper .suffix {\n  padding: 0 10px;\n  font-size: 12px;\n  color: #94A3B8;\n  background: #F8FAFC;\n}\n\n.exercice-detail-modal .hypothesis-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.exercice-detail-modal .formula {\n  font-size: 10px;\n  color: #94A3B8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.exercice-detail-modal .hypothesis-value {\n  font-size: 12px;\n  color: #64748B;\n}\n\n.exercice-detail-modal .override-notice {\n  margin-top: 6px;\n  font-size: 11px;\n  color: #D97706;\n  font-style: italic;\n}\n\n/* ===================== SUMMARY SECTION ===================== */\n\n.exercice-detail-modal .summary-section {\n  background: #F8FAFC;\n  border-radius: 12px;\n  padding: 16px;\n}\n\n.exercice-detail-modal .summary-section h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1E293B;\n  margin: 0 0 12px 0;\n}\n\n.exercice-detail-modal .summary-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.exercice-detail-modal .summary-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 0;\n}\n\n.exercice-detail-modal .summary-row .row-label {\n  font-size: 13px;\n  color: #64748B;\n}\n\n.exercice-detail-modal .summary-row .row-value {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1E293B;\n}\n\n.exercice-detail-modal .summary-row .row-value.negative {\n  color: #DC2626;\n}\n\n.exercice-detail-modal .summary-row.resultat {\n  border-top: 1px solid #E2E8F0;\n  padding-top: 10px;\n  margin-top: 4px;\n}\n\n.exercice-detail-modal .summary-row.is .is-detail {\n  font-size: 11px;\n  color: #94A3B8;\n  margin-left: 6px;\n}\n\n.exercice-detail-modal .summary-row.highlight {\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  margin: 8px -16px -16px;\n  padding: 12px 16px;\n  border-radius: 0 0 12px 12px;\n}\n\n.exercice-detail-modal .summary-row.highlight .row-label,\n.exercice-detail-modal .summary-row.highlight .row-value {\n  color: white;\n  font-weight: 600;\n}\n\n.exercice-detail-modal .ir-notice {\n  padding: 12px;\n  background: #EFF6FF;\n  border: 1px solid #BFDBFE;\n  border-radius: 8px;\n  font-size: 12px;\n  color: #1E40AF;\n  text-align: center;\n}\n\n/* ===================== FOOTER ===================== */\n\n.exercice-detail-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 20px;\n  border-top: 1px solid #E2E8F0;\n  background: #FAFAFA;\n}\n\n.exercice-detail-modal .btn-cancel {\n  padding: 10px 20px;\n  background: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.exercice-detail-modal .btn-cancel:hover {\n  background: #F1F5F9;\n  border-color: #CBD5E1;\n}\n\n.exercice-detail-modal .btn-save {\n  padding: 10px 24px;\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: white;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.exercice-detail-modal .btn-save:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);\n}\n\n/* ===================== DETAIL SECTIONS ===================== */\n\n.exercice-detail-modal .detail-section {\n  background: #F8FAFC;\n  border-radius: 10px;\n  padding: 14px 16px;\n  margin-bottom: 16px;\n  border: 1px solid #E2E8F0;\n}\n\n.exercice-detail-modal .detail-section h4 {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1E293B;\n  margin: 0 0 10px 0;\n}\n\n.exercice-detail-modal .detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 0;\n  font-size: 13px;\n  color: #475569;\n}\n\n.exercice-detail-modal .detail-row span.negative {\n  color: #DC2626;\n  font-weight: 500;\n}\n\n.exercice-detail-modal .detail-row.total {\n  border-top: 1px solid #E2E8F0;\n  margin-top: 6px;\n  padding-top: 10px;\n  font-weight: 600;\n}\n\n.exercice-detail-modal .detail-row.total span {\n  color: #1E293B;\n}\n\n/* ===================== ACRE BADGE ===================== */\n\n.exercice-detail-modal .acre-badge {\n  display: inline-block;\n  padding: 2px 6px;\n  background: #DCFCE7;\n  color: #16A34A;\n  border-radius: 4px;\n  font-size: 9px;\n  font-weight: 600;\n  margin-left: 6px;\n}\n\n/* ===================== EXEMPTION NOTE ===================== */\n\n.exercice-detail-modal .exemption-note {\n  font-size: 10px;\n  color: #16A34A;\n  font-style: italic;\n  margin-left: 4px;\n}\n\n/* ===================== RESPONSIVE ===================== */\n\n@media (max-width: 640px) {\n  .exercice-detail-modal {\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n    max-height: 100%;\n    border-radius: 0;\n  }\n\n  .exercice-detail-modal .charge-input-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n  }\n\n  .exercice-detail-modal .input-wrapper {\n    width: 100%;\n  }\n\n  .exercice-detail-modal .hypothesis-info {\n    flex-direction: row;\n    gap: 8px;\n  }\n}\n\n/* ===================== YEAR BADGE ===================== */\n\n.exercice-detail-modal .year-badge {\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.exercice-detail-modal .year-badge.first {\n  background: #DCFCE7;\n  color: #16A34A;\n}\n\n.exercice-detail-modal .year-badge.second {\n  background: #FEF3C7;\n  color: #D97706;\n}\n\n/* ===================== ACTIVE OPTIONS BAR ===================== */\n\n.exercice-detail-modal .active-options-bar {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n  min-height: 28px;\n}\n\n.exercice-detail-modal .option-tag {\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.exercice-detail-modal .option-tag.acre {\n  background: #DCFCE7;\n  color: #16A34A;\n}\n\n.exercice-detail-modal .option-tag.jei {\n  background: #DBEAFE;\n  color: #2563EB;\n}\n\n.exercice-detail-modal .option-tag.cir {\n  background: #F3E8FF;\n  color: #9333EA;\n}\n\n.exercice-detail-modal .option-tag.mf {\n  background: #FEF3C7;\n  color: #D97706;\n}\n\n.exercice-detail-modal .option-tag.cga {\n  background: #E0E7FF;\n  color: #4F46E5;\n}\n\n/* ===================== CA SECTION EDITABLE ===================== */\n\n.exercice-detail-modal .detail-row.editable {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.exercice-detail-modal .edit-value {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.exercice-detail-modal .edit-value input {\n  width: 140px;\n  padding: 8px 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 14px;\n  text-align: right;\n}\n\n.exercice-detail-modal .edit-value input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.exercice-detail-modal .edit-value input.overridden {\n  background: #FEF3C7;\n  border-color: #F59E0B;\n  font-weight: 500;\n}\n\n.exercice-detail-modal .edit-value .suffix {\n  font-size: 13px;\n  color: #64748B;\n}\n\n.exercice-detail-modal .override-note {\n  font-size: 11px;\n  color: #D97706;\n  font-style: italic;\n  margin-top: 4px;\n  text-align: right;\n}\n\n/* ===================== MANAGER DETAIL ROW ===================== */\n\n.exercice-detail-modal .manager-detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.exercice-detail-modal .manager-detail-row:last-of-type {\n  border-bottom: none;\n}\n\n.exercice-detail-modal .manager-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.exercice-detail-modal .manager-role {\n  font-weight: 500;\n  color: #1E293B;\n  font-size: 13px;\n}\n\n.exercice-detail-modal .status-badge {\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.exercice-detail-modal .status-badge.tns {\n  background: #FEE2E2;\n  color: #DC2626;\n}\n\n.exercice-detail-modal .status-badge.as {\n  background: #DBEAFE;\n  color: #2563EB;\n}\n\n.exercice-detail-modal .tag-small {\n  padding: 2px 5px;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.exercice-detail-modal .tag-small.acre {\n  background: #DCFCE7;\n  color: #16A34A;\n}\n\n.exercice-detail-modal .tag-small.jei {\n  background: #DBEAFE;\n  color: #2563EB;\n}\n\n.exercice-detail-modal .manager-amounts {\n  display: flex;\n  gap: 16px;\n}\n\n.exercice-detail-modal .amount-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n}\n\n.exercice-detail-modal .amount-item label {\n  font-size: 10px;\n  color: #94A3B8;\n  text-transform: uppercase;\n}\n\n.exercice-detail-modal .amount-item span {\n  font-size: 13px;\n  font-weight: 500;\n  color: #1E293B;\n}\n\n.exercice-detail-modal .amount-item span.negative {\n  color: #DC2626;\n}\n\n.exercice-detail-modal .amount-item.total span {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n/* ===================== CIR CREDIT ROW ===================== */\n\n.exercice-detail-modal .summary-row.cir-credit {\n  padding-left: 20px;\n}\n\n.exercice-detail-modal .summary-row.cir-credit .row-label {\n  font-size: 12px;\n  font-style: italic;\n}\n\n.exercice-detail-modal .row-value.positive {\n  color: #16A34A;\n  font-weight: 500;\n}\n\n/* ===================== HEADER ACTIONS ===================== */\n\n.exercice-detail-modal .header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.exercice-detail-modal .toggle-formulas {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.9);\n  cursor: pointer;\n}\n\n.exercice-detail-modal .toggle-formulas input {\n  accent-color: white;\n}\n\n/* ===================== MODAL COLUMNS ===================== */\n\n.exercice-detail-modal .modal-columns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.exercice-detail-modal .modal-column {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ===================== CHARGES OBLIGATOIRES ===================== */\n\n.exercice-detail-modal .section-subtitle {\n  font-size: 11px;\n  color: #64748B;\n  margin: 0 0 12px 0;\n}\n\n.exercice-detail-modal .charges-group {\n  margin-bottom: 16px;\n}\n\n.exercice-detail-modal .group-label {\n  display: block;\n  font-size: 10px;\n  font-weight: 600;\n  color: #94A3B8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n/* ===================== EDITABLE ROW ===================== */\n\n.exercice-detail-modal .row-label-with-help {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.exercice-detail-modal .tooltip-wrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.exercice-detail-modal .help-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  background: #E2E8F0;\n  border-radius: 50%;\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748B;\n  cursor: help;\n  transition: all 0.15s;\n}\n\n.exercice-detail-modal .help-icon:hover {\n  background: #3B82F6;\n  color: white;\n}\n\n.exercice-detail-modal .tooltip-content {\n  position: absolute;\n  left: 24px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: #1E293B;\n  color: white;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 400;\n  white-space: nowrap;\n  max-width: 300px;\n  white-space: normal;\n  z-index: 100;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  animation: tooltipFadeIn 0.15s ease-out;\n}\n\n.exercice-detail-modal .tooltip-content::before {\n  content: '';\n  position: absolute;\n  left: -6px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: 6px solid transparent;\n  border-right-color: #1E293B;\n}\n\n@keyframes tooltipFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-50%) translateX(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(-50%) translateX(0);\n  }\n}\n\n/* Hint pour pas de charges */\n.exercice-detail-modal .no-charges-hint {\n  font-size: 12px;\n  color: #94A3B8;\n  font-style: italic;\n  padding: 8px 0;\n}\n\n.exercice-detail-modal .row-value-edit {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.exercice-detail-modal .formula-hint {\n  font-size: 10px;\n  color: #94A3B8;\n  font-style: italic;\n  white-space: nowrap;\n}\n\n.exercice-detail-modal .detail-row.overridden {\n  background: #FEF3C7;\n  border-color: #F59E0B;\n}\n\n/* ===================== SECTION TOTAL ===================== */\n\n.exercice-detail-modal .section-total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  margin-top: 8px;\n  border-top: 1px solid #E2E8F0;\n  font-weight: 600;\n}\n\n.exercice-detail-modal .section-total .negative {\n  color: #DC2626;\n}\n\n/* ===================== MANAGER EDIT ===================== */\n\n.exercice-detail-modal .manager-edit {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.exercice-detail-modal .edit-value.compact {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.exercice-detail-modal .edit-value.compact input {\n  width: 100px;\n  padding: 6px 8px;\n  font-size: 13px;\n}\n\n/* ===================== NO OPTIONS ===================== */\n\n.exercice-detail-modal .no-options {\n  font-size: 12px;\n  color: #94A3B8;\n  font-style: italic;\n}\n\n/* ===================== FOOTER INFO ===================== */\n\n.exercice-detail-modal .modal-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-top: 1px solid #E2E8F0;\n  background: #FAFAFA;\n}\n\n.exercice-detail-modal .footer-info {\n  flex: 1;\n}\n\n.exercice-detail-modal .override-count {\n  font-size: 12px;\n  color: #D97706;\n  font-weight: 500;\n}\n\n.exercice-detail-modal .footer-actions {\n  display: flex;\n  gap: 10px;\n}\n\n/* ===================== RESPONSIVE ===================== */\n\n@media (max-width: 900px) {\n  .exercice-detail-modal .modal-columns {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
